export default {
  watch: {
    valid(newValue) {
      this.$emit("validation", this.question.id, newValue);
    },
  },
  mounted() {
    this.$emit("validation", this.question.id, this.valid);
  },
};
